// Предзагрузка локальных шрифтов, чтобы уменьшить лаги при первом рендере
// Используем FontFace API и импорт путей через бандлер

import ysTextRegularTtf from '../assets/fonts/YSText/YS Text-Regular.ttf';
import ysTextMediumTtf from '../assets/fonts/YSText/YS Text-Medium.ttf';
import ysTextBoldTtf from '../assets/fonts/YSText/YS Text-Bold.ttf';
import ysDisplayBoldTtf from '../assets/fonts/YSText/YS Display-Bold.ttf';

import caveatVarTtf from '../assets/fonts/Caveat/Caveat-VariableFont_wght.ttf';

export function preloadFonts() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.resolve();
  }

  if (!('fonts' in document) || typeof window.FontFace !== 'function') {
    return Promise.resolve();
  }

  // Создаем массив промисов для всех шрифтов
  const fontPromises = [];

  // YS Text Regular — основной текстовый шрифт
  const ysTextRegular = new FontFace(
    'YS Text',
    `url("${ysTextRegularTtf}") format('truetype')`,
    { style: 'normal', weight: '400', display: 'block' }
  );
  fontPromises.push(ysTextRegular.load().then(font => document.fonts.add(font)));

  // YS Text Medium — для кнопок
  const ysTextMedium = new FontFace(
    'YS Text',
    `url("${ysTextMediumTtf}") format('truetype')`,
    { style: 'normal', weight: '500', display: 'block' }
  );
  fontPromises.push(ysTextMedium.load().then(font => document.fonts.add(font)));

  // YS Text Bold — для акцентов
  const ysTextBold = new FontFace(
    'YS Text',
    `url("${ysTextBoldTtf}") format('truetype')`,
    { style: 'normal', weight: '700', display: 'block' }
  );
  fontPromises.push(ysTextBold.load().then(font => document.fonts.add(font)));

  // YS Display Bold — для заголовков
  const ysDisplayBold = new FontFace(
    'YS Display',
    `url("${ysDisplayBoldTtf}") format('truetype')`,
    { style: 'normal', weight: '700', display: 'block' }
  );
  fontPromises.push(ysDisplayBold.load().then(font => document.fonts.add(font)));

  // Caveat — рукописный шрифт для письма (ПРИОРИТЕТНАЯ ЗАГРУЗКА)
  const caveat = new FontFace(
    'Caveat',
    `url("${caveatVarTtf}") format('truetype')`,
    { style: 'normal', weight: '400 700', display: 'block' }
  );
  fontPromises.push(caveat.load().then(font => document.fonts.add(font)));

  // Загружаем все шрифты параллельно и ждем завершения
  return Promise.all(fontPromises)
    .then(() => {
      console.log('✅ Все шрифты успешно загружены');
    })
    .catch((error) => {
      console.warn('⚠️ Ошибка при загрузке шрифтов:', error);
    });
}
